
<br />
<br />
<br />
<div style="margin:0 auto;width:400px;min-height:400px;border:1px solid #ddd;padding:10px;text-align:center">
  <form [formGroup]="registerForm" novalidate>
    <div style="text-align:center;">
      <img src="../../../assets/backgroundImgs/頁首LOGO.png" style="width:80%;" />
      <br />
      <span style="font-size:23px;font-weight:bold">課程管理系統試用版</span>
    </div>
    <br />
    <div style="padding:5px">
      <label style="font-size:medium;display:inline-block;width:80px;text-align:left">帳號</label>
      <input formControlName="id" style="font-size:large;padding:3px 10px;border:1px solid #bbb;border-radius:5px;width:210px" />
    </div>
    <div style="padding:5px">
      <label style="font-size: medium; display: inline-block; width: 80px; text-align: left ">密碼</label>
      <input formControlName="password" type="password" style="font-size:large;padding:3px 10px;border:1px solid #bbb;border-radius:5px;width:210px" />
    </div>
    <div style="padding:5px">
      <label style="font-size: medium; display: inline-block; width: 80px; text-align: left ">確認密碼</label>
      <input formControlName="passwordCheck" type="password" style="font-size:large;padding:3px 10px;border:1px solid #bbb;border-radius:5px;width:210px" />
    </div>
    <div style="padding:5px">
      <label style="font-size: medium; display: inline-block; width: 80px; text-align: left ">機構名稱</label>
      <input formControlName="name" style="font-size:large;padding:3px 10px;border:1px solid #bbb;border-radius:5px;width:210px" />
    </div>
    <div style="padding:5px">
      <label style="font-size: medium; display: inline-block; width: 80px; text-align: left ">電話</label>
      <input formControlName="phone" style="font-size:large;padding:3px 10px;border:1px solid #bbb;border-radius:5px;width:210px" />
    </div>
    <div style="padding:5px">
      <label style="font-size: medium; display: inline-block; width: 80px; text-align: left ">地址</label>
      <input formControlName="address" style="font-size:large;padding:3px 10px;border:1px solid #bbb;border-radius:5px;width:210px" />
    </div>
    <div style="padding:5px">
      <label style="font-size: medium; display: inline-block; width: 80px; text-align: left ">統編</label>
      <input formControlName="taxId" style="font-size:large;padding:3px 10px;border:1px solid #bbb;border-radius:5px;width:210px" />
    </div>
    <div style="padding:5px">
      <label style="font-size: medium; display: inline-block; width: 80px; text-align: left ">EMAIL</label>
      <input formControlName="email" style="font-size:large;padding:3px 10px;border:1px solid #bbb;border-radius:5px;width:210px" />
    </div>
    <div style="padding: 5px;">
      <label style="font-size: medium; display: inline-block; width: 80px; text-align: left ">部門</label>
      <select formControlName="department" style="font-size:large;padding:3px 10px;border:1px solid #bbb;border-radius:5px;width:210px">
        <option [value]=""></option>
        <option *ngFor="let item of globalVar.departmentOptions" [value]="item">{{ item }}</option>
      </select>
    </div>
    <div style="padding: 5px; ">
      <label style="font-size: medium; display: inline-block; width: 80px; text-align: left ">頭像<button mat-icon-button type="button" (click)="fileInput.click()" matTooltip="選擇相片"><mat-icon>attachment</mat-icon></button></label>
      <input formControlName="picture" style="font-size:large;padding:3px 10px;border:1px solid #bbb;border-radius:5px;width:210px" />
      <input hidden (change)="uploadFile($event)" #fileInput type="file" accept="image/*">
    </div>

    <br /><br />
    <div style="text-align:center">
      <button mat-raised-button color="primary" (click)="postRegister(registerForm.value)" matTooltip="註冊" style="width: 200px">註冊</button>
    </div>
    <br /><br />
  </form>
</div>

